'use client';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Fragment } from 'react';
import { useInternalOptionalSwanI18nContext } from '../../contexts/i18n/swan-i18n-provider.context.js';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { useDeprecatedProps } from '../../hooks/use-deprecated-props.js';
import { getDeprecatedI18nPropMessage } from '../../hooks/use-required-i18n-props.js';
import { Box } from '../box/box.component.js';
import { Link } from '../link/link.component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { RenderComp } from '../core/render-comp.component.js';
import { FlexBox } from '../flex-box/flex-box.component.js';
import { VisuallyHidden } from '../visually-hidden/visually-hidden.component.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, n = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), n.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t.push.apply(t, n);
    }
    return t;
}
function _object_spread_props(e, r) {
    return r = null != r ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    }), e;
}
function _object_without_properties(e, r) {
    if (null == e) return {};
    var t, n, s = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        for(n = 0; n < o.length; n++)t = o[n], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (s[t] = e[t]);
    }
    return s;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var t, n, s = {}, o = Object.keys(e);
    for(n = 0; n < o.length; n++)t = o[n], r.indexOf(t) >= 0 || (s[t] = e[t]);
    return s;
}
const RatingsStars = renderWithRef('RatingsStars', null, (o, b)=>{
    let d = useInternalOptionalSwanI18nContext();
    useDeprecatedProps('RatingsStars', o, [
        {
            propName: 'accessibleTextForReviewCount',
            instructions: getDeprecatedI18nPropMessage(d)
        },
        {
            propName: 'aria-label',
            instructions: getDeprecatedI18nPropMessage(d)
        }
    ]), useComponentStylesLoaded('RatingsStars', SWAN_STYLE_KEY_MAP.ratingsStars);
    let { skin: g = 'standard', ratingValue: w = 0, hideRating: y = false, reviews: O, href: h, 'aria-label': j, accessibleTextForReviewCount: _ } = o, x = _object_without_properties(o, [
        "skin",
        "ratingValue",
        "hideRating",
        "reviews",
        "href",
        'aria-label',
        "accessibleTextForReviewCount"
    ]), v = _, P = j;
    d && !P && (P = d.t('ratings-stars.accessible-text', {
        rating: w
    })), d && !v && (v = d.t(d.getPluralKey(h ? 'ratings-stars.accessible-link-text-for-review-count' : 'ratings-stars.accessible-text-for-review-count', O || 0), {
        count: O || 0
    }));
    let [S, k] = w.toFixed(1).split('.').map((e)=>Number(e)), N = [
        'swan-ratings'
    ];
    return 'standard' !== g && N.push(`swan-ratings-skin-${g}`), jsx(RenderComp, {
        root: "div",
        props: x,
        forwardedRef: b,
        classNames: N,
        children: jsxs(FlexBox, {
            className: "swan-ratings-stars-container",
            flexWrap: "wrap",
            alignItems: "center",
            gap: 2,
            children: [
                jsx(Box, {
                    className: "swan-ratings-stars",
                    role: "img",
                    "aria-label": P,
                    children: Array.from({
                        length: 5
                    }).map((r, t)=>{
                        let n = [
                            'swan-ratings-star'
                        ];
                        return t + 1 <= S && n.push('swan-ratings-star-filled'), (k && t + 1) === S + 1 && n.push(`swan-ratings-star-filled-p${k}`), jsx("span", {
                            className: n.join(' ')
                        }, `star_${t}`);
                    })
                }),
                !y && jsx("span", {
                    className: "swan-ratings-stars-rating",
                    "aria-hidden": P ? 'true' : 'false',
                    children: w
                }),
                null != O && jsxs("span", {
                    className: "swan-ratings-stars-reviews",
                    children: [
                        "(",
                        jsxs(h ? Link : Fragment, _object_spread_props(_object_spread({}, h ? {
                            to: h
                        } : {}), {
                            children: [
                                jsx("span", {
                                    "aria-hidden": v ? 'true' : 'false',
                                    children: O
                                }),
                                v && jsx(VisuallyHidden, {
                                    children: v
                                })
                            ]
                        })),
                        ")"
                    ]
                })
            ]
        })
    });
});

export { RatingsStars };
